import { LotStatus, Unit } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type LotAllocationInput = {
  movementId: string;
  quantity: {
    value: number;
    unit: Unit;
  };
};

export const createInventoryLotAtom = createMutationAtomFactory(
  'inventory.createInventoryLot',
  (params: {
    lotNumber: string;
    facilityId: string;
    zoneId?: string;
    description?: string;
  }) => ({
    inventoryLotCreate: {
      __args: {
        input: {
          lotNumber: params.lotNumber,
          facilityId: params.facilityId,
          zoneId: params.zoneId,
          description: params.description,
        },
      },
      id: true,
      lotNumber: true,
      facilityId: true,
      facility: {
        id: true,
        facilityName: true,
      },
      zoneId: true,
      zone: {
        id: true,
        zoneCode: true,
      },
      status: true,
      description: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);

export const updateInventoryLotAtom = createMutationAtomFactory(
  'inventory.updateInventoryLot',
  (params: {
    lotId: string;
    lotNumber?: string;
    zoneId?: string | null;
    description?: string;
    status?: LotStatus;
  }) => ({
    inventoryLotUpdate: {
      __args: {
        id: params.lotId,
        input: {
          lotNumber: params.lotNumber,
          zoneId: params.zoneId,
          description: params.description,
          status: params.status,
        },
      },
      id: true,
      lotNumber: true,
      facilityId: true,
      facility: {
        id: true,
        facilityName: true,
      },
      zoneId: true,
      zone: {
        id: true,
        zoneCode: true,
      },
      status: true,
      description: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);

export const allocateToLotAtom = createMutationAtomFactory(
  'inventory.allocateToLot',
  (params: { lotId: string; allocations: LotAllocationInput[] }) => ({
    inventoryLotAllocate: {
      __args: {
        input: {
          lotId: params.lotId,
          allocations: params.allocations.map((alloc) => ({
            movementId: alloc.movementId,
            quantity: {
              value: alloc.quantity.value,
              unit: alloc.quantity.unit,
            },
          })),
        },
      },
      lot: {
        id: true,
        lotNumber: true,
        status: true,
      },
      allocations: {
        id: true,
        movementId: true,
        quantity: {
          value: true,
          unit: true,
        },
        timestamps: {
          createdAt: true,
        },
      },
    },
  }),
);

export const deallocateFromLotAtom = createMutationAtomFactory(
  'inventory.deallocateFromLot',
  (params: { allocationIds: string[] }) => ({
    inventoryLotDeallocate: {
      __args: {
        input: {
          allocationIds: params.allocationIds,
        },
      },
    },
  }),
);
